import { useTranslation } from 'react-i18next';

import DownloadCard from './DownloadCard/DownloadCard';
import * as appLinks from '../../constants/appLinks';
import classes from './Download.module.css';


const Download = (props) => {
    const {t} = useTranslation();
    return (
        <section id="download" className={classes.Download}>
            <div className="container">
                <div className={classes.Title}>
                    <small>{t('download.subtitle')}</small>
                    <h3>{t('download.title')}</h3>
                </div>
                <div>
                    <div className="row">
                        <div className="col-3">
                            <DownloadCard
                                title={t('download.rider')}
                                apple={true}
                                downloadLink={appLinks.appleRiderLink} />
                        </div>
                        <div className="col-3">
                            <DownloadCard
                                title={t('download.rider')}
                                apple={false}
                                downloadLink={appLinks.googlePlayRiderLink} />
                        </div>
                        <div className="col-3">
                            <DownloadCard
                                title={t('download.driver')}
                                apple={true}
                                downloadLink={appLinks.appleDriverLink} />
                        </div>
                        <div className="col-3">
                            <DownloadCard
                                title={t('download.driver')}
                                apple={false}
                                downloadLink={appLinks.googlePlayDriverLink} />
                        </div>
                    </div>
                </div>
            </div>

        </section>
    );
}

export default Download;